import { action } from 'satcheljs/lib/legacy';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
/**
 * Removes the attachment well and the attachment view states for given row
 * @param rowId for which the attachment view state are to be cleared
 */
export default action('removeAttachmentPreviewsForRow')(function removeAttachmentPreviewsForRow(rowId) {
    var attachmentPreviewWellViews = listViewStore.rowAttachmentPreviewWellViews;
    var attachmentPreviewWellView = attachmentPreviewWellViews.get(rowId);
    if (!attachmentPreviewWellView) {
        return;
    }
    var attachmentViewStates = listViewStore.attachmentViewStates;
    // Clear all image attachment view states
    attachmentPreviewWellView.imageViewStateIds.forEach(function (imageAttachmentViewStateKey) {
        attachmentViewStates.delete(imageAttachmentViewStateKey);
    });
    // Clear all document attachment view states
    attachmentPreviewWellView.documentViewStateIds.forEach(function (docAttachmentViewStateKey) {
        attachmentViewStates.delete(docAttachmentViewStateKey);
    });
    // Delete the attachment well view state
    attachmentPreviewWellViews.delete(rowId);
});
//# sourceMappingURL=removeAttachmentPreviewsForRow.js.map